import { InsertionEditorElements } from '../../../@types/types'
import { FlowElementProps, FlowInformation, FlowScreenElement } from '../../../@types/flow-types'
import { SCREEN_MULTIMEDIA, SCREENS } from '../../../services/domain/wizardScreens'
import { ValidationResult } from '../../../@types/validation-types'

export const getElementProps = (
  {
    insertionEditorState: { insertionData, validationResult },
    insertionEditorMethods: { doResetInsertionData, onChange, onNavigate, doCloseMultimediaStatusMessage },
  }: InsertionEditorElements,
  component: FlowScreenElement,
  flowInformation: FlowInformation
): FlowElementProps => ({
  flowInformation: flowInformation,
  insertionData: insertionData,
  flowName: flowInformation.name,
  validationMessages: validationResult[component.screen.name as keyof ValidationResult]?.fields,
  onNavigate: onNavigate,
  onChange: onChange,
  doReset: doResetInsertionData,
  doCloseMultimediaStatusMessage:
    component.screen.name === SCREENS[SCREEN_MULTIMEDIA].name ? doCloseMultimediaStatusMessage : undefined,
})
